import { useDispatch } from "react-redux";
import {
  SelectedTab,
  setIsPropertiesColumnOpen,
  setSelectedTab,
  setShowCameraWidget,
} from "../app/slices/GlobalSlice";
import {
  clearTraining,
  resetIsDirty,
  setIsPlaying,
} from "../app/slices/TrainingSlice";
import { cleanupCurrentEnvironment } from "../app/slices/EnvironmentSlice";
import { resetEnvironmentProps } from "../app/slices/EnvironmentPropSlice";
import { clearLocalization } from "../app/slices/TrainingLocalizationSlice";
import { WebSocketService } from "../services/WebSocketService";
import {
  clearLocalChanges,
  ConnectionState,
  setConnectionStatus,
} from "../app/slices/WebSocketSlice";
import { setTrainingFilter } from "../app/slices/ProjectsSlice";
import {
  CreatorNetworkMessage,
  CreatorNetworkMessageType,
} from "../models/CreatorNetworkMessage";
import { resetHistory } from "../app/slices/HistorySlice";

export default function useOnExitEditor() {
  const dispatch = useDispatch();

  const onExitEditorCleanup = () => {
    dispatch(resetHistory());
    dispatch(setIsPropertiesColumnOpen(true));
    dispatch(setSelectedTab(SelectedTab.Timeline));
    dispatch(setIsPlaying({ isPlaying: false, data: "" }));
    dispatch(resetIsDirty());
    dispatch(cleanupCurrentEnvironment());
    dispatch(resetEnvironmentProps());
    dispatch(clearLocalization());

    //TODO: should probably clean up props and situations ?
    dispatch(clearTraining());

    // clear local changes
    dispatch(clearLocalChanges());
    dispatch(setTrainingFilter(""));

    // disconnect from unity if we are connected
    if (WebSocketService.isConnected()) {
      const msg: CreatorNetworkMessage = {
        messageType: CreatorNetworkMessageType.AbortScenario,
        data: "",
      };
      WebSocketService.sendMessage(JSON.stringify(msg));
      WebSocketService.sendMessage(JSON.stringify(msg));
      WebSocketService.disconnect();
      dispatch(setConnectionStatus(ConnectionState.notReadyForScenario));
    }
  };

  return { onExitEditorCleanup } as const;
}
